import {PrivateCommand} from "../PrivateCommand";
import cmp from "../../../context/context";

class GDPRAlreadyAccepted extends PrivateCommand {

    public execute(option?: string, callback?: Function): void {
        // Indicamos que el consentimiento ya está aceptado
        cmp().gdprAlreadyAccepted();
    }
}

export {GDPRAlreadyAccepted}
